import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store/index';

/** ------------------------------
 * アプリ連携用 コンポーネント
 * ------------------------------ */
import MobileLink from  './pages/mobile/mobileLink';

/** ------------------------------
 * 予約系 コンポーネント
 * ------------------------------ */
// 試験用画面
import ResrvePageTopDummy from  './pages/ReservePage/ResrvePageTopDummy';
// 予約カレンダー画面（プラン選択画面）
import Reserve from  './pages/ReservePage/Reserve';
// スタート時間・人数選択画面
import StartTimeSelect from './pages/ReservePage/StartTimeSelect';
// リクエスト時間選択画面
import RequestTimeSelect from './pages/ReservePage/RequestTimeSelect';
// 同伴者リスト画面
import CompanionList from './pages/ReservePage/CompanionList';
// 同伴者組合せ画面
import RegistCompanion from './pages/ReservePage/RegistCompanion';
// 予約確認画面
import ConfirmationReserveContent from './pages/ReservePage/ConfirmationReserveContent';
// 予約完了画面
import CompleteScreen from './pages/ReservePage/CompleteScreen';
// プラン説明ダイアログ画面
import ExplanationPlanDialog from'./pages/ReservePage/dialog/ExplanationPlanDialog';
// アイコン説明ダイアログ画面
import ExplanationIconDialog from './pages/ReservePage/dialog/ExplanationIconDialog';
// 表説明ダイアログ画面
import ExplanationTableDialog from './pages/ReservePage/dialog/ExplanationTableDialog';
// プレーヤ入力ダイアログ画面
import InputPlayerDialog from './pages/ReservePage/dialog/InputPlayerDialog';
/** ------------------------------
 * 予約ゴルフ場サイト埋め込み用 コンポーネント
 * ------------------------------ */
import ResrveEmbedded from './pages/ReservePage/ReserveEmbedded';
/** ------------------------------
 * 会員登録系 コンポーネント
 * ------------------------------ */
// 会員登録方法選択画面
import SignUpChoice from './pages/signup/SignupChoice';
// 仮登録完了画面
import SignupProvisional from './pages/signup/SignupProvisionalComplete';
// 会員情報入力画面
import SignupForm from './pages/signup/SignupForm';
// 会員登録完了画面
import SignupComplete from './pages/signup/SignupComplete';
// ログイン方法選択画面
import SignInChoice from './pages/signup/SigninChoice';
/** ------------------------------
 * ヘルプ系 コンポーネント
 * ------------------------------ */
//新規作成ヘルプ
import HelpMakeAccount from './pages/help/HelpMakeAccount';
//登録内容変更ヘルプ
import HelpAccountEdit from './pages/help/HelpAccountEdit';
//パスワードヘルプ
import HelpPassforget from './pages/help/HelpPassforget';
//ポイントヘルプ
import HelpPoint from './pages/help/HelpPoint';
// マイページヘルプ
import HelpMypage from './pages/help/HelpMypage';
// 予約ヘルプ
import HelpReserveChange from './pages/help/HelpReserveChange';
/** ------------------------------
 * ログイン前 コンポーネント
 * ------------------------------ */
// マイページログイン画面
import SigninForm from './pages/signin/SigninForm';
// パスワード再設定メール送信完了画面
import PasswordMail from './pages/signin/PasswordMail';
// パスワード再設定画面
import PasswordResetting from './pages/signin/PasswordResetting';
// パスワード再設定完了画面
import PasswordResettingComplete from './pages/signin/PasswordResettingComplete';
// マイページトップ画面
import MypageTop from './pages/mypage/MypageTop';
// ポイント照会画面
import MypagePointTop from './pages/mypage/MypagePointTop';
// ポイント履歴画面
import MypagePoint from './pages/mypage/MypagePoint';
// 会員情報参照画面
import MypageInfo from './pages/mypage/MypageInfo';
// パスワード変更画面
import MypagePasswordChange from './pages/mypage/MypagePasswordChange';
// パスワード変更完了画面
import MypagePasswordComplete from './pages/mypage/MypagePasswordComplete';
// プロフィール登録画面
import MypageProfile from './pages/mypage/MypageProfile';
// 会員退会画面
import MypageMemberQuit from './pages/mypage/MypageMemberQuit';
// 会員退会完了画面
import MypageMemberQuitComplete from './pages/mypage/MypageMemberQuitComplete';
// 会員情報変更画面
import MypageMemberSetting from './pages/mypage/MypageMemberSetting';
// 会員情報変更画面
import MypageInfoSetting from './pages/mypage/MypageInfoSetting';
// 会員情報変更完了画面
import MypageInfoSettingComplete from './pages/mypage/MypageInfoSettingComplete';
// 会員情報変更完了画面
import MypageMemberSettingSendMail from './pages/mypage/MypageMemberSettingSendMail';
// 会員情報変更完了画面
import MypageMemberSettingComplete from './pages/mypage/MypageMemberSettingComplete';
// 携帯番号変更画面
import MypageMobileChange from './pages/mypage/MypageMobileChange';
// 携帯番号変更完了画面
import MypageMobileComplete from './pages/mypage/MypageMobileComplete';
// LINEアカウント連携画面
import MypageLineSetting from './pages/mypage/MypageLineSetting';
// LINEアカウント連携完了画面
import MypageLineSettingComplete from './pages/mypage/MypageLineSettingComplete';
// LINEアカウント連携解除画面
import MypageLineSettingQuit from './pages/mypage/MypageLineSettingQuit';
// LINEアカウント連携解除完了画面
import MypageLineSettingQuitComplete from './pages/mypage/MypageLineSettingQuitComplete';
// 会員番号バーコード表示画面
import MypageLineCode from './pages/mypage/MypageLineCode';
// 連携カード番号参照画面
import MypageCardNo from './pages/mypage/MypageCardNo';
// 予約状況一覧画面
import MypageReserveList from './pages/mypage/MypageReserveList';
// 予約状況照会画面
import MypageReserveReference from './pages/mypage/MypageReserveReference';
// 予約状況変更画面
import MypageReserveUpdate from './pages/mypage/MypageReserveUpdate';
// お友達登録画面
import MypageFriendList from './pages/mypage/MypageFriendList';
// お友達承認画面
import MypageFriendApproval from './pages/mypage/MypageFriendApproval';
// 予約連携承認画面
import MypageReserveApproval from './pages/mypage/MypageReserveApproval';
// お問い合わせ入力画面(一般)
import InquiryInput from './pages/mypage/InquiryInput';
// お問い合わせ入力画面(予約)
import InquiryForReserve from './pages/mypage/InquiryForReserve';
// お知らせ一覧
import MypageDeliveryActualsList from './pages/mypage/MypageDeliveryActualsList';
// お知らせ詳細
import MypageDeliveryActualsReference from './pages/mypage/MypageDeliveryActualsReference';
// 登録メール送信
import MypageMailSetting from './pages/mypage/MypageMailSetting';
// 受信拒否設定
import MypageRejectionSetting from './pages/mypage/MypageRejectionSetting';
// 受信拒否設定完了画面
import MypageRejectionSettingComplete from './pages/mypage/MypageRejectionSettingComplete';
// 明細書
import Specification from './pages/mypage/Specification';
// 宛名入力
import MyPageInputAddressee from './pages/mypage/MyPageInputAddressee';
// 領収書
import Receipt from './pages/mypage/Receipt';
// 実績一覧
import MypageResultList from './pages/mypage/MypageResultList';
// 実績詳細
import MypageResultReference from './pages/mypage/MypageResultReference';
/** ------------------------------
 * 無人チェックイン
 * ------------------------------ */
// チェックイン
import MypageVisitCheckin from './pages/mypage/MypageVisitCheckin';
//チェックアウト
import MypageVisitCheckout from './pages/mypage/MypageVisitCheckout';
// 精算番号参照
import MypageVisitSettlement from './pages/mypage/MypageVisitSettlement';
// ロッカー番号
import MypageVisitLockerNo from './pages/mypage/MypageVisitLockerNo';
// レストランオーダー
import MypageVisitRestaurant from './pages/mypage/MypageVisitRestaurant';
/** ------------------------------
 * クラシック用 コンポーネント
 * ------------------------------ */
// マイページトップ画面
import ClMypageTop from './pages/mypage/ClMypageTop';
// 会員情報参照画面
import ClMypageInfo from './pages/mypage/ClMypageInfo';
// 会員情報変更画面
import ClMypageInfoSetting from './pages/mypage/ClMypageInfoSetting';
// 予約状況一覧画面
import ClMypageReserveList from './pages/mypage/ClMypageReserveList';
// 予約状況照会画面
import ClMypageReserveReference from './pages/mypage/ClMypageReserveReference';
// お問い合わせ入力画面(一般)
import ClInquiryInput from './pages/mypage/ClInquiryInput';
// 実績一覧
import ClMypageResultList from './pages/mypage/ClMypageResultList';
// 同伴者変更期限画面
import MypageDeadlineCompanion from './pages/mypage/MypageDeadlineCompanion';
// ゴルフ場一覧画面
import GolfCourseList from './pages/ReservePage/GolfCourseList';

Vue.use(VueRouter);

const routes = [
    // ゴルフ場サイト埋め込み用画面
    {
        path: '/resrvelink',
        component: ResrveEmbedded,
        name: 'ResrveEmbedded',
        meta: { useWebReserve: true }
    },
    // トップダミー画面
    {
        path: '/dummy',
        component: ResrvePageTopDummy,
        meta: { useWebReserve: true }
    },
    // 予約カレンダー画面
    {
        path: '/reserve',
        component: Reserve,
        name: 'reservepage',
        meta: { useWebReserve: true }
    },
    // スタート時間・人数選択画面
    {
        path: '/starttime',
        component: StartTimeSelect,
        name: 'StartTimeSelect',
        meta: { useWebReserve: true }
    },
    // リクエスト時間選択画面
    {
        path: '/requesttimeselect',
        component: RequestTimeSelect,
        name: 'RequestTimeSelect',
        meta: { useWebReserve: true }
    },
    // 同伴者リスト
    {
        path: '/companion-list',
        component: CompanionList,
        name: 'CompanionList',
        meta: { requiresAuth: true }
    },
    // 同伴者追加画面
    {
        path: '/registcompanion',
        component: RegistCompanion,
        name: 'RegistCompanion',
        meta: { requiresAuth: true }
    },
    // 予約完了画面
    {
        path: '/complete',
        component: CompleteScreen,
        meta: { requiresAuth: true }
    },
    // 予約確認画面
    {
        path: '/reservecontent',
        component: ConfirmationReserveContent,
        meta: { requiresAuth: true }
    },
    //プラン詳細ダイアログ画面
    {
        path: '/plandialog',
        component: ExplanationPlanDialog
    },
    // アイコン説明ダイアログ画面
    {
        path: '/icondialog',
        component: ExplanationIconDialog
    },
    // 表説明ダイアログ画面
    {
        path: '/tabledialog',
        component: ExplanationTableDialog
    },
    // プレーヤ入力ダイアログ画面
    {
        path: '/inputdialog',
        component: InputPlayerDialog
    },
    // 会員登録方法選択画面
    {
        path: '/signup',
        component: SignUpChoice
    },
    // ログイン方法選択画面
    {
        path: '/signin',
        component: SignInChoice
    },
    // ヘルプ(新規登録に関して)画面
    {
        path: '/help',
        component: HelpMakeAccount
    },
    // ヘルプ(登録内容変更)画面
    {
        path: '/help-accountedit',
        component: HelpAccountEdit
    },
    // ヘルプ(パスワード)画面
    {
        path: '/help-passforget',
        component: HelpPassforget
    },
    // ヘルプ(ポイント)画面
    {
        path: '/help-point',
        component: HelpPoint
    },
    // ヘルプ(マイページ)画面
    {
        path: '/help-mypage',
        component: HelpMypage
    },
    // ヘルプ予約画面
    {
        path: '/help-reserve-change',
        component: HelpReserveChange
    },
    // 仮登録完了画面
    {
        path: '/signup-provisional',
        component: SignupProvisional
    },
    // 会員情報入力画面
    {
        path: '/signup-form',
        component: SignupForm
    },
    // 会員登録完了画面
    {
        path: '/signup-complete',
        component: SignupComplete
    },

    // マイページログイン画面（サイトトップ）
    {
        path: '/',
        component: SigninForm
    },
    // パスワード再設定メール送信完了画面
    {
        path: '/passreset-mail',
        component: PasswordMail
    },
    // パスワード再設定画面
    {
        path: '/passreset-setting',
        component: PasswordResetting
    },
    // パスワード再設定完了画面
    {
        path: '/passreset-setting-complete',
        component: PasswordResettingComplete
    },
    // マイページ：トップ
    {
        path: '/mypage',
        component: process.env.MIX_STYLE_NAME === 'hcgc' ? ClMypageTop : MypageTop,
        meta: { requiresAuth: true }
    },
    // マイページ：ポイント照会
    {
        path: '/mypage-point-top',
        component: MypagePointTop,
        meta: { requiresAuth: true}
    },
    // マイページ：ポイント履歴
    {
        path: '/mypage-point',
        component: MypagePoint,
        meta: { requiresAuth: true }
    },
    // マイページ：会員情報の参照・変更
    {
        path: '/mypage-info',
        component: process.env.MIX_STYLE_NAME === 'hcgc' ? ClMypageInfo : MypageInfo,
        meta: { requiresAuth: true }
    },
    // マイページ：携帯番号変更
    {
        path: '/mypage-mobile-change',
        component: MypageMobileChange,
        meta: { requiresAuth: true }
    },
    // マイページ：携帯番号変更完了
    {
        path: '/mypage-mobile-complete',
        component: MypageMobileComplete,
        meta: { requiresAuth: true }
    },
    // マイページ：パスワード変更
    {
        path: '/mypage-passchange',
        component: MypagePasswordChange,
        meta: { requiresAuth: true }
    },
    // マイページ：パスワード変更完了
    {
        path: '/mypage-passchange-complete',
        component: MypagePasswordComplete,
        meta: { requiresAuth: true }
    },
    // マイページ：プロフィール画面
    {
        path: '/mypage-profile',
        component: MypageProfile,
        meta: { requiresAuth: true }
    },
    // マイページ：会員退会
    {
        path: '/mypage-quit',
        component: MypageMemberQuit,
        name: 'MypageMemberQuit',
        meta: { requiresAuth: true }
    },
    // マイページ：会員退会完了
    {
        path: '/mypage-quit-complete',
        component: MypageMemberQuitComplete,
        name: 'MypageMemberQuitComplete'
    },
    // マイページ：会員情報変更
    {
        path: '/mypage-member-setting',
        component: MypageMemberSetting,
        meta: { requiresAuth: true }
    },
    // マイページ：会員情報変更
    {
        path: '/mypage-info-change',
        component: process.env.MIX_STYLE_NAME === 'hcgc' ? ClMypageInfoSetting : MypageInfoSetting,
        meta: { requiresAuth: true }
    },
    // マイページ：会員情報変更完了画面
    {
        path: '/mypage-info-complete',
        component: MypageInfoSettingComplete,
        meta: { requiresAuth: true }
    },
    // マイページ：会員情報変更メール送信完了画面
    {
        path: '/mypage-member-setting-send-mail',
        component: MypageMemberSettingSendMail,
        meta: { requiresAuth: true }
    },
    // マイページ：会員情報変更完了
    {
        path: '/mypage-member-setting-complete',
        component: MypageMemberSettingComplete,
        name: 'MypageMemberSettingComplete'
    },
    // マイページ：LINEアカウント連携
    {
        path: '/mypage-line-setting',
        component: MypageLineSetting,
        meta: { requiresAuth: true }
    },
    // マイページ：LINEアカウント連携完了
    {
        path: '/mypage-line-setting-complete',
        component: MypageLineSettingComplete,
        name: 'MypageLineSettingComplete',
        meta: { requiresAuth: true }
    },
    // マイページ：LINEアカウント連携解除
    {
        path: '/mypage-line-setting-quit',
        component: MypageLineSettingQuit,
        meta: { requiresAuth: true }
    },
    // マイページ：LINEアカウント連携解除完了
    {
        path: '/mypage-line-setting-quit-complete',
        component: MypageLineSettingQuitComplete,
        name: 'MypageLineSettingQuitComplete',
        meta: { requiresAuth: true }
    },
    // 会員番号バーコード表示画面
    {
        path: '/mypage-line-code',
        component: MypageLineCode,
        meta: { requiresAuth: true }
    },
    // 連携カード番号参照画面
    {
        path: '/mypage-card',
        component: MypageCardNo,
        meta: { requiresAuth: true }
    },
    // 予約状況一覧画面
    {
        path: '/mypage-reserve-list',
        component: process.env.MIX_STYLE_NAME === 'hcgc' ? ClMypageReserveList : MypageReserveList,
        name: 'MypageReserveList',
        meta: { requiresAuth: true }
    },
    // 予約状況照会画面
    {
        path: '/mypage-reserve-reference',
        component: process.env.MIX_STYLE_NAME === 'hcgc' ? ClMypageReserveReference : MypageReserveReference,
        name: 'MypageReserveReference',
        meta: { requiresAuth: true }
    },
    // 予約状況変更画面
    {
        path: '/mypage-reserve-update',
        component: MypageReserveUpdate,
        name: 'MypageReserveUpdate',
        meta: { requiresAuth: true }
    },
    // お友達一覧画面
    {
        path: '/mypage-friend-List',
        component: MypageFriendList,
        name: 'MypageFriendList',
        meta: { requiresAuth: true }
    },
    // お友達承認画面
    {
        path: '/friend-approval',
        component: MypageFriendApproval,
        name: 'MypageFriendApproval',
        meta: { requiresAuth: true }
    },
    // 予約連携承認画面
    {
        path: '/reserve-approval',
        component: MypageReserveApproval,
        name: 'MypageReserveApproval',
        meta: { requiresAuth: true }
    },
    // お問い合わせ画面(一般)
    {
        path: '/contact',
        component: process.env.MIX_STYLE_NAME === 'hcgc' ? ClInquiryInput : InquiryInput,
        name: 'InquiryInput',
        meta: { requiresAuth: true, useChatbox: true }
    },
    // お問い合わせ画面(予約)
    {
        path: '/mypage-reserve-contact',
        component: InquiryForReserve,
        name: 'InquiryForReserve',
        meta: { requiresAuth: true, useChatbox: true }
    },
    // お知らせ一覧
    {
        path: '/mypage-delivery-actuals-list',
        component: MypageDeliveryActualsList,
        name: 'MypageDeliveryActualsList',
        meta: { requiresAuth: true }
    },
    // お知らせ詳細
    {
        path: '/mypage-delivery-actuals-reference',
        component: MypageDeliveryActualsReference,
        name: 'MypageDeliveryActualsReference',
        meta: { requiresAuth: true }
    },
    // 登録メール送信
    {
        path: '/MypageMailSetting',
        component: MypageMailSetting,
    },
    // 受信拒否設定
    {
        path: '/MypageRejectionSetting',
        component: MypageRejectionSetting,
    },
    // 受信拒否設定完了画面
    {
        path: '/MypageRejectionSettingComplete',
        component: MypageRejectionSettingComplete,
    },
    // 明細書
    {
        path: '/Specification',
        component: Specification,
        meta: { requiresAuth: true }
    },
    // 宛名入力
    {
        path: '/mypage-input-addressee',
        component: MyPageInputAddressee,
        name: 'MyPageInputAddressee',
        meta: { requiresAuth: true }
    },
    // 領収書
    {
        path: '/Receipt',
        component: Receipt,
        meta: { requiresAuth: true }
    },
    // 実績一覧
    {
        path: '/mypage-result-list',
        component: process.env.MIX_STYLE_NAME === 'hcgc' ? ClMypageResultList : MypageResultList,
        name: 'MypageResultList',
        meta: { requiresAuth: true }
    },
    // 実績詳細
    {
        path: '/mypage-result-reference',
        component: MypageResultReference,
        name: 'MypageResultReference',
        meta: { requiresAuth: true }
    },
    // 同伴者変更期限画面
    {
        path: '/mypage-deadline-companion',
        component: MypageDeadlineCompanion,
        name: 'MypageDeadlineCompanion',
        meta: { requiresAuth: true }
    },
    /** ------------------------------
     * 無人チェックイン
     * ------------------------------ */
    // チェックイン
    {
        path: '/mypage-visit-checkin',
        component: MypageVisitCheckin,
        meta: { requiresAuth: true }
    },
    // チェックアウト
    {
        path: '/mypage-visit-checkout',
        component: MypageVisitCheckout,
        meta: { requiresAuth: true }
    },
    // 精算番号参照
    {
        path: '/mypage-visit-settlement',
        component: MypageVisitSettlement,
        meta: { requiresAuth: true }
    },
    // ロッカー番号
    {
        path: '/mypage-visit-locker-no',
        component: MypageVisitLockerNo,
        meta: { requiresAuth: true }
    },
    // レストランオーダー
    {
        path: '/mypage-visit-restaurant',
        component: MypageVisitRestaurant,
        meta: { requiresAuth: true }
    },
    // ゴルフ場一覧画面
    {
        path: '/golf-course-list',
        component: GolfCourseList,
        name: 'GolfCourseLisst',
        props: true
    },
    // アプリ・予約詳細
    {
        path: '/app/mypage-reserve-reference',
        component: MobileLink,
        name: 'MobileLinkMypageReserveReference',
        meta: { requiresAuth: true }
    },
    // アプリ・予約変更
    {
        path: '/app/mypage-reserve-update',
        component: MobileLink,
        name: 'MobileLinkMypageReserveUpdate',
        meta: { requiresAuth: true }
    },
    // アプリ・同伴者リスト
    {
        path: '/app/companion-list',
        component: MobileLink,
        name: 'MobileLinkCompanionList',
        meta: { requiresAuth: true }
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

// ルーティング前の処理を差し込む
router.beforeEach(async (to, from, next) => {
    store.commit('loading/setIsLoading', true);

    // システム設定の機能を確認する
    await store.dispatch('auth/getSettingValue');

    // WEB予約機能を使用しない場合は予約画面ではなくログイン画面に遷移させる
    if (store.state.auth.settingValueWebReserve === 0) {
        // 予約機能で使用するURLのmetaにはuseWebReserveがtrueで設定されているので、そのページには遷移させない。
        if (to.matched.some(record => record.meta.useWebReserve)) {
            next('/');
        }
    }

    // Chatbox機能を使用しない場合はログイン画面に遷移させる
    if (store.state.auth.settingValueChatbox === 0) {
        // Chatbox機能のURLのmetaにはuseWebReserveがtrueで設定されているので、そのページには遷移させない。
        if (to.matched.some(record => record.meta.useChatbox)) {
            next('/');
        }
    }

    // auth認証が必要ページ
    if (to.matched.some(record => record.meta.requiresAuth)) {
        await store.dispatch('auth/getLoginMember');

        // 取得が失敗した場合はunAuthorizedなので弾いてトップへ
        if (!store.state.auth.loginMember) {
            // アプリの場合は各処理を実行
            if (store.state.auth.mobileAppFlag) {
                switch (process.env.MIX_STYLE_NAME) {
                    case 'esv':
                        AppUtil.postToApp("login", {redirectUrl: process.env.MIX_APP_REDIRECT_URL})
                        break;
                    default:
                        next('/');
                        break;
                }
            } else {
                next('/');
            }
        }
    }

    next();
});

// ルーティング後の処理
router.afterEach(() => {
    // loading画面終了
    store.commit('loading/setIsLoading', false);
});

export default router;
